import React, { Fragment, useRef, useEffect } from 'react';
import { translate } from '../Services/translation';

const NavigationItem = ({ links = [], contentLink = null, newsLink = null, offerLink = null, myPageLink = null, logoutLink = null, textColor = null, buttonColor = null, buttonTextColor = null, channelName = null, level = 0 }) => {
    const menuRef = useRef(null);
    const toggleMenu = (e) => {
        e.preventDefault();
        menuRef.current.classList.toggle('navbar__menu--show');
        const navItem = menuRef.current.closest('.navbar__item');
        if (navItem) {
            navItem.classList.toggle('navbar__menu--showing');
            const navParent = menuRef.current.closest('ul');
            if (navParent) {
                navParent.classList.toggle('navbar__menu--has-active-sub');
            }
        }
        // Toggle body
        const bodyEl = document.querySelector('body');
        if (bodyEl) {
            const isTopElActive = document.querySelector('.navbar > .navbar__menu--show');
            if (isTopElActive) {
                bodyEl.classList.add('navbar__menu--is-active');
            } else {
                bodyEl.classList.remove('navbar__menu--is-active');
            }
        }
    };
    const additionClass =
        contentLink && contentLink.attributes
            ? contentLink.attributes.cssValue
            : null;
    const selectedClass =
        contentLink && contentLink.isSelected ? 'navbar__link--selected' : '';
    const hasChildrenClass = links.length > 0 ? 'has-children' : null;

    const hasNameOrChildren = (link) =>
        link.name || (link.links || []).length > 0;

    const handleMenuOpen = (event) => {
        if (event.currentTarget.getElementsByClassName("navbar__menu")[0] && event.target.classList.contains("has-children")) {
            if (document.querySelectorAll(".navbar__menu.show")) {
                let allMenus = document.querySelectorAll(".navbar__menu.show");
                for (let i = 0; i < allMenus.length; i++) {
                    allMenus[i].classList.remove("show");
                }
            }
            event.currentTarget.getElementsByClassName("navbar__menu")[0].classList.add("show");
        }
    }

    const closeOpenMenu = (e) => {
        let allMenus = document.querySelectorAll(".navbar__menu.show");
        if (allMenus && allMenus.length > 0 && e.target && !e.target.matches('[ class^="navbar" ]')) {
            for (let i = 0; i < allMenus.length; i++) {
                allMenus[i].classList.remove("show");
            }
        }
    }

    useEffect(() => {
        document.addEventListener('mouseover', closeOpenMenu);

        return () => {
            document.removeEventListener('mouseover', closeOpenMenu);
        };
    }, []);

    return (
        <Fragment>
            {!contentLink ? (
                <a
                    className="navbar__link--block navbar__icon--menu navbar__icon"
                    onClick={toggleMenu}
                    rel="nofollow"
                    href="#"
                    title={translate('general.menu') || 'menu'}
                ></a>
            ) : (
                <Fragment>
                    {contentLink.iconUrl ? (
                        <a
                            className={`navbar__link ${selectedClass} ${hasChildrenClass || ''
                                } ${additionClass || ''}`}
                            href={contentLink.url || '#'}
                            style={level == 1 && textColor ? { color: textColor } : undefined}
                            dangerouslySetInnerHTML={{ __html: `<img src=${contentLink.iconUrl} alt="" class="navbar__link--icon" />` + contentLink.name }}
                            title={contentLink.name}
                        ></a>
                    ) : (
                        <a
                            className={`navbar__link ${selectedClass} ${hasChildrenClass || ''
                                } ${additionClass || ''}`}
                            href={contentLink.url || '#'}
                            style={level == 1 && textColor ? { color: textColor } : undefined}
                            dangerouslySetInnerHTML={{ __html: `${level == 1 ? '<div class="navbar__link--icon"></div>' : ''}` + contentLink.name }}
                            title={contentLink.name}
                        ></a>

                    )}

                    {links.length > 0 && (
                        <i
                            className="navbar__icon--caret-right navbar__icon navbar__icon--open"
                            onClick={toggleMenu}
                        ></i>
                    )}
                </Fragment>
            )}

            {links.length > 0 && (
                <div className="navbar__menu" ref={menuRef}>
                    <div className="navbar__menu-header">
                        {!contentLink ? (
                            <span
                                className="navbar__icon navbar__icon--close"
                                onClick={toggleMenu}
                            ></span>
                        ) : (
                            <Fragment>
                                <i
                                    className="navbar__icon--caret-left navbar__icon"
                                    onClick={toggleMenu}
                                ></i>
                                <span
                                    className="navbar__title"
                                    onClick={toggleMenu}
                                    dangerouslySetInnerHTML={{
                                        __html: contentLink.name,
                                    }}
                                ></span>
                            </Fragment>
                        )}
                    </div>
                    <ul className="navbar__menu-links">
                        {myPageLink &&
                            <li className="navbar__item hide-for-large">
                                <a
                                    className={`navbar__link`}
                                    href={myPageLink.url || '#'}
                                    dangerouslySetInnerHTML={{ __html: `<img src=${myPageLink.iconUrl} alt="" class="navbar__link--icon" />` + myPageLink.name }}
                                ></a>
                            </li>
                        }
                        {links.length > 0 &&
                            links.map(
                                (link, index) =>
                                    hasNameOrChildren(link) && (
                                        <li
                                            className={`${link.isCategoryLink ? `navbar__item navbar__item-category${channelName?.toLowerCase() === "horselux" ? "-horselux" : ""}` : "navbar__item"}`}
                                            key={index}
                                            onMouseOver={(event) => handleMenuOpen(event)}
                                        >
                                            <NavigationItem
                                                links={link.links}
                                                contentLink={link}
                                                textColor={textColor}
                                                buttonColor={buttonColor}
                                                buttonTextColor={buttonTextColor}
                                                level={level + 1}
                                            />

                                        </li>
                                    )
                            )}

                    </ul>
                    {/*Campaign area*/}
                    {contentLink?.megaMenuExtra && level == 1 && (
                        <div className="navbar__campaign-area">
                            <div className="navbar__campaign-image-wrapper hide-for-small-only"><img className="navbar__campaign-image" src={contentLink.megaMenuExtra.imageUrl} alt={contentLink.megaMenuExtra.imageUrl} /></div>
                            <div className="navbar__campaign-title">{contentLink.megaMenuExtra.title}</div>
                            <a className="navbar__campaign-button button" href={contentLink.megaMenuExtra.link} style={{
                                ...(buttonColor && { backgroundColor: buttonColor }),
                                ...(buttonTextColor && { color: buttonTextColor })
                            }}>{contentLink.megaMenuExtra.linkText}</a>
                        </div>
                    )}
                    {/*Right links */}
                    {level == 0 && (
                        <div className="navbar__rightlinks">
                            {newsLink && (
                                <div className="navbar__rightlink">
                                    <span className="navbar__rightlink--title hide-for-small-only hide-for-medium-only" style={textColor ? { color: textColor } : undefined}>{translate("code.megamenu.newslink.header")}</span>
                                    <div className="navbar__rightlink--newslink">
                                        <a href={newsLink.url} title={newsLink.name} className={`${newsLink.isSelected ? "is-active" : ''}`} style={textColor ? { color: textColor } : undefined}>
                                            {newsLink.iconUrl &&
                                                <img src={newsLink.iconUrl} alt="" className="navbar__rightlink--newsicon" />
                                            }
                                            {newsLink.name}
                                        </a>
                                    </div>
                                </div>
                            )}

                            {offerLink && (
                                <div className="navbar__rightlink">
                                    <div className="navbar__rightlink--offerlink" style={buttonColor ? { '--offer-bg-color': buttonColor } : undefined}>
                                        <a href={offerLink.url} title={offerLink.name} className={`${offerLink.isSelected ? "is-active" : ''}`} style={buttonTextColor ? { color: buttonTextColor } : undefined}>
                                            {offerLink.iconUrl &&
                                                <img src={offerLink.iconUrl} alt="" className="navbar__rightlink--offericon" />
                                            }
                                            {offerLink.name}
                                        </a>
                                    </div>
                                </div>
                            )}
                        </div>
                    )}

                    {logoutLink &&
                        <div className="navbar__item hide-for-large">
                            <a
                                className={`navbar__link`}
                                href={logoutLink.url || '#'}
                                dangerouslySetInnerHTML={{ __html: `<img src="ui/images/logout-1.svg" alt=${logoutLink.name} class="navbar__link--icon" />` + logoutLink.name }}
                            ></a>
                        </div>
                    }
                </div>
            )}
        </Fragment>
    );
};

export default NavigationItem;
